import React, { useCallback } from "react";
import sort from "../../images/sort.svg";
import add from "../../images/add.svg";
import close from "../../images/close.png";
import { NavLink } from "react-router-dom";
import Tipster from "./tipster";
import TipsterFunction from "./tipsterFunction";

function Functions({ setText }) {
  const toggleMenu = useCallback(() => {
    const doc = document.querySelector(".side_menu");
    const doc_parent = document.querySelector(".side_menu_parant");
    if (doc && doc_parent) {
      doc.classList.toggle("side_menu_close");
      setTimeout(() => {
        doc_parent.classList.toggle("side_menu_parant_");
      }, 300);
    }
  }, []);

  return (
    <div className="container_">
      <div className="flex lg:flex-row md:flex-row flex-col justify-between">
        <div className="flex lg:flex-row md:flex-row flex-col lg:w-[60%] w-full gap-4 justify-start items-center mt-10">
          <input
            type="text"
            onChange={(event) => setText && setText(event.target.value)}
            placeholder="Search Tipster"
            className="lg:w-[65%] md:w-[50%] w-full lg:text-[16px] text-[14px] h-[60px] lg:h-[66px] pl-6 placeholder-black-200 rounded-[40px]"
          />
          {/* <div className="flex rounded-[40px] lg:text-[15px] md:text-[14px] text-[14px] justify-center items-center gap-2 bg-[#fff] lg:h-[66px] h-[60px] lg:w-[18%] md:w-[27%] w-full">
            <img src={sort} className="img-fluid sort" alt="sort" />
            Filter
          </div> */}
        </div>
        <div className="flex lg:mt-10 mt-[1.3rem] md:mt-10 rounded-[40px] justify-center items-center gap-2 bg-[#fff] lg:h-[66px] h-[60px] lg:w-[20%] md:w-[40%] w-full">
          <NavLink to="/post">
            <div className="flex justify-center items-center">
              <img
                src={add}
                className="img-fluid sort lg:w-[16px] lg:h-[16px] h-[14px] w-[14px]"
                alt="add"
              />
              <p className="lg:text-[16px] text-[14px]"> Post Booking Code</p>
            </div>
          </NavLink>
        </div>
      </div>

      <div
        class="offcanvas offcanvas-start"
        data-bs-backdrop="static"
        tabindex="-1"
        id="staticBackdrop"
        aria-labelledby="staticBackdropLabel"
      >
        <div class="offcanvas-header">
          <img
            src={close}
            className="close"
            type="button"
            alt="close"
            data-bs-dismiss="offcanvas"
          />
        </div>
        <div class="offcanvas-body">
          <div>
            <h5 class="filter-header">Filter booking codes by </h5>

            <h6 className="criteria-title">Odds</h6>

            <input
              className="input-z"
              placeholder="Enter Minimum Odds Value"
              type="number"
            />
            <input
              className="input-z"
              placeholder="Enter Maximum Odds Value"
              type="number"
            />

            <h6 className="criteria-title">Booking Platform</h6>
            <div className="container block-check">
              <span className="title-check">
                {" "}
                <input type="checkbox" value="yes" class="check" /> Sporty Bet{" "}
              </span>
              <span className="title-check">
                {" "}
                <input type="checkbox" value="yes" class="check" /> 1X Bet{" "}
              </span>{" "}
              <br></br>
              <span className="title-check">
                {" "}
                <input type="checkbox" value="yes" class="check" /> Bet King{" "}
              </span>
              <span className="title-check">
                {" "}
                <input type="checkbox" value="yes" class="check" /> Merry Bet{" "}
              </span>{" "}
              <br></br>
              <span className="title-check">
                {" "}
                <input type="checkbox" value="yes" class="check" /> Betano{" "}
              </span>
              <span className="title-check">
                {" "}
                <input type="checkbox" value="yes" class="check" /> Bet Naija{" "}
              </span>{" "}
              <br></br>
              <span className="title-check">
                {" "}
                <input
                  type="checkbox"
                  value="yes"
                  class="check"
                /> Surebet247{" "}
              </span>
              <span className="title-check">
                {" "}
                <input type="checkbox" value="yes" class="check" /> Others{" "}
              </span>
            </div>

            <button className="btn-filter">Apply filter</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Functions;
